import React, {Component} from "react";
import {Buffer} from "buffer";
import {Button, Form, Input, Modal} from "antd";
import {offerApiServices} from "../../services/offer/OfferApiService";
import {offerGeneralApiService} from "../../services/offer/OfferGeneralApiService";
import Cookies from "universal-cookie";

class UpdatePhoneNumber extends Component<any, any> {
    private readonly initState!: any;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString())

    constructor(props: any) {
        super(props);
        this.initState = {
            offerCode: "",

            ownerPhoneNumber: "",
            updateProcess: false,
        }
        this.state = {...this.initState}
    }

    async componentDidMount() {
        await this.promisedSetState({
            offerCode: this.props.offerCode,
            ownerPhoneNumber: this.props.ownerPhoneNumber,
            ownerAlternativePhoneNumber: this.props.ownerAlternativePhoneNumber,
            orderMakerPhoneNumber: this.props.orderMakerPhoneNumber,
            poPhoneNumber: this.props.poPhoneNumber,
        });
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.time !== prevProps.time) {
            await this.promisedSetState({
                offerCode: this.props.offerCode,
                ownerPhoneNumber: this.props.ownerPhoneNumber,
                ownerAlternativePhoneNumber: this.props.ownerAlternativePhoneNumber,
                orderMakerPhoneNumber: this.props.orderMakerPhoneNumber,
                poPhoneNumber: this.props.poPhoneNumber,
            });
        }
    }

    onFieldChange = <T extends keyof Pick<any, "ownerPhoneNumber" | "ownerAlternativePhoneNumber" | "orderMakerPhoneNumber" | "poPhoneNumber">>(target: T, value: any) => {
        const currentState = {...this.state};
        switch (target) {
            case "ownerPhoneNumber":
                currentState.ownerPhoneNumber = value;
                break;
            case "ownerAlternativePhoneNumber":
                currentState.ownerAlternativePhoneNumber = value;
                break;
            case "orderMakerPhoneNumber":
                currentState.orderMakerPhoneNumber = value;
                break;
            case "poPhoneNumber":
                currentState.poPhoneNumber = value;
                break;
        }

        this.setState({
            ...currentState,
        });
    }

    onUpdateData = async () => {
        const dataUpdate = {
            update_type: "phone-number",
            company: this.props.companyCode,
            admin_id: this.user,
            admin_name: this.user,
            offer_code: this.state.offerCode,
            owner_phone_number: this.state.ownerPhoneNumber,
            owner_alternative_phone_number: this.state.ownerAlternativePhoneNumber,
            order_maker_phone_number: this.state.orderMakerPhoneNumber,
        };

        await this.promisedSetState({updateProcess: true});

        if (this.props.type === "offer") {
            try {
                await offerApiServices.updateOffer(dataUpdate).then(successData => {
                    Modal.success({title: 'Proses Sukses', content: 'Offer berhasil di update'});
                    this.setState({updateProcess: false});
                    this.props.onCloseUpdatePhoneNumberProps("close");
                });
            } catch (e) {
                Modal.error({title: 'Proses Gagal', content: 'Server Menolak Inputan Anda :' + e});
                await this.promisedSetState({updateProcess: false,});
            }
        } else if (this.props.type === "generalOffer") {
            try {
                await offerGeneralApiService.updateOffer(dataUpdate).then(successData => {
                    Modal.success({title: 'Proses Sukses', content: 'Offer berhasil di update'});
                    this.setState({updateProcess: false});
                    this.props.onCloseUpdatePhoneNumberProps("close");
                });
            } catch (e) {
                Modal.error({title: 'Proses Gagal', content: 'Server Menolak Inputan Anda :' + e});
                await this.promisedSetState({updateProcess: false,});
            }
        }
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <div>
                    Offer Code: {this.state.offerCode}<br/><br/>
                    <Form layout="vertical">
                        <Form.Item>
                            <i className={`text-small-grey-nopadding`}><b className={`required`}>*</b> Nomor Telpon Pemilik *</i>
                            <Input
                                value={this.state.ownerPhoneNumber}
                                placeholder="Nomor Telpon Pemilik"
                                onChange={event => this.onFieldChange("ownerPhoneNumber", event.target.value)}
                            />
                        </Form.Item>

                        <Form.Item style={(this.props.type === "offer") ? {} : {display: "none"}}>
                            <i className={`text-small-grey-nopadding`}>Nomor Telpon Pemilik Alternatif</i>
                            <Input
                                value={this.state.ownerAlternativePhoneNumber}
                                placeholder="Nomor Telpon Pemilik Alternatif"
                                onChange={event => this.onFieldChange("ownerAlternativePhoneNumber", event.target.value)}
                            />
                        </Form.Item>

                        <Form.Item style={(this.props.type === "offer") ? {} : {display: "none"}}>
                            <i className={`text-small-grey-nopadding`}>Nomor Telpon Pemesan</i>
                            <Input
                                value={this.state.orderMakerPhoneNumber}
                                placeholder="Nomor Telpon Pemesan"
                                onChange={event => this.onFieldChange("orderMakerPhoneNumber", event.target.value)}
                            />
                        </Form.Item>

                        <br/>
                        <Button type={"primary"} loading={this.state.updateProcess} onClick={() => this.onUpdateData()}> Update Data</Button>
                    </Form>
                </div>
            </React.Fragment>
        );
    }
}

export default UpdatePhoneNumber;
